import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';


const Th = styled.th`
 ${({ theme, displayState }) => {
  return css`
    text-align: left;
    min-width: ${displayState?.minWidth ? displayState?.minWidth : ""};
    padding-right: ${displayState?.paddingRight ? displayState?.paddingRight : ""};

  `}}
`;

export default Wrapper(Th)
